<div class="fgbcl-game-predictor-result-answer-section">
  <div class="fgbcl-game-predictor-result-anwser-card">
    <div class="fgbcl-game-predictor-result-anwser-card-text">{{ 'fgbcl.game.predictor.you.guessed.text' | translate }}</div>
    <div class="fgbcl-game-predictor-result-answers" *ngIf="multiCounter">{{ answers[0].Value }} - {{ answers[1].Value }}</div>
    <div class="fgbcl-game-predictor-result-answers fgbcl-game-predictor-guessed-answer" *ngIf="!multiCounter">
      {{ answers[0].Value }}
    </div>
  </div>
  <div class="fgbcl-game-predictor-result-anwser-card">
    <div class="fgbcl-game-predictor-result-anwser-card-text">{{ 'fgbcl.game.predictor.correct.answer.text' | translate }}</div>
    <div class="fgbcl-game-predictor-result-answers fgbcl-game-predictor-correct-answer" *ngIf="multiCounter">
      {{ answers[0].CorrectValue }} - {{ answers[1].CorrectValue }}
    </div>
    <div class="fgbcl-game-predictor-result-answers fgbcl-game-predictor-correct-answer" *ngIf="!multiCounter">
      {{ answers[0].CorrectValue }}
    </div>
  </div>
</div>
